exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#modal-add-edit___BV_modal_outer_ {\n  z-index: 1050 !important;\n}\n", ""]);

// exports
